var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.7V17.05C0 17.3539 0.246125 17.6 0.55 17.6H3.3V6.6H1.1C0.492594 6.6 0 7.0926 0 7.7ZM12.375 6.05H11.55V4.675C11.55 4.52307 11.4269 4.4 11.275 4.4H10.725C10.5731 4.4 10.45 4.52307 10.45 4.675V6.875C10.45 7.02694 10.5731 7.15 10.725 7.15H12.375C12.5269 7.15 12.65 7.02694 12.65 6.875V6.325C12.65 6.17307 12.5269 6.05 12.375 6.05ZM17.1102 3.85138L11.6102 0.184597C11.4294 0.0642263 11.2171 0 11 0C10.7829 0 10.5706 0.0642263 10.3898 0.184597L4.88984 3.85138C4.7392 3.95181 4.61567 4.08788 4.53022 4.24751C4.44477 4.40713 4.40004 4.58538 4.4 4.76644V17.6H8.8V12.65C8.8 12.3461 9.04613 12.1 9.35 12.1H12.65C12.9539 12.1 13.2 12.3461 13.2 12.65V17.6H17.6V4.76678C17.6 4.39897 17.4161 4.05522 17.1102 3.85138ZM11 8.8C9.48131 8.8 8.25 7.56869 8.25 6.05C8.25 4.53132 9.48131 3.3 11 3.3C12.5187 3.3 13.75 4.53132 13.75 6.05C13.75 7.56869 12.5187 8.8 11 8.8ZM20.9 6.6H18.7V17.6H21.45C21.7539 17.6 22 17.3539 22 17.05V7.7C22 7.0926 21.5074 6.6 20.9 6.6Z",
    fill: "#8D90A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/schoolIcon.24f748babc31f92805b022b68719c461.svg";
export { ForwardRef as ReactComponent };